import { sdkFactory as wixSocialGroupsV2Group_sdkFactory_groups } from './src/social-groups-v2-group.frontend';
import { sdkFactory as wixSocialGroupsV2GroupMember_sdkFactory_members } from './src/social-groups-v2-group-member.frontend';
import { sdkFactory as wixSocialGroupsV2GroupRequest_sdkFactory_groupRequests } from './src/social-groups-v2-group-request.frontend';
import { sdkFactory as wixSocialGroupsV2GroupRole_sdkFactory_roles } from './src/social-groups-v2-group-role.frontend';
import { sdkFactory as wixSocialGroupsV2GroupRules_sdkFactory_rules } from './src/social-groups-v2-group-rules.frontend';
import { sdkFactory as wixSocialGroupsV2JoinGroupRequest_sdkFactory_joinGroupRequests } from './src/social-groups-v2-join-group-request.frontend';
import { sdkFactory as wixSocialGroupsV2MembershipQuestion_sdkFactory_membershipQuestions } from './src/social-groups-v2-membership-question.frontend';
export function sdkFactory(args) {
    return {
        groups: wixSocialGroupsV2Group_sdkFactory_groups(args),
        members: wixSocialGroupsV2GroupMember_sdkFactory_members(args),
        groupRequests: wixSocialGroupsV2GroupRequest_sdkFactory_groupRequests(args),
        roles: wixSocialGroupsV2GroupRole_sdkFactory_roles(args),
        rules: wixSocialGroupsV2GroupRules_sdkFactory_rules(args),
        joinGroupRequests: wixSocialGroupsV2JoinGroupRequest_sdkFactory_joinGroupRequests(args),
        membershipQuestions: wixSocialGroupsV2MembershipQuestion_sdkFactory_membershipQuestions(args),
    };
}
//# sourceMappingURL=index.frontend.js.map